import React from "react";
import StatCard from "../widgets/StatCard";
import RecentUsersTable from "../widgets/RecentUsersTable";
import QuickActions from "../widgets/QuickActions";

const UserInfoTab = ({ data }) => {
  return (
    <div className="user-dashboard">
      {/* KPI strip (top row) */}
      <div className="kpi-strip">
        <StatCard label="Total Users" value={data.totalUsers} />
        <StatCard label="Administrators" value={data.adminCount} />
        <StatCard label="Trainees" value={data.traineeCount} />
      </div>

      {/* Main: 8 / 4 split */}
      <div className="dashboard-main">
        <section className="card">
          <div className="card-header">
            <h2 className="card-title">Recent Users</h2>
          </div>
          <RecentUsersTable users={data.recentUsers || []} />
        </section>

        <aside className="dashboard-rail">
          <div className="card rail-sticky">
            <div className="card-header">
              <h2 className="card-title">Quick Actions</h2>
            </div>
            <QuickActions />
          </div>
        </aside>
      </div>
    </div>
  );
};

export default UserInfoTab;
